import { Dialog, DialogContent } from "@mui/material"
import "./MapSideModal.scss"
import CloseIcon from '@mui/icons-material/Close';
import { ISelectedMapPoint } from "../../map-models";
import MapSideModalContent from "../MapSideModalContent/MapSideModalContent";
import { useEffect, useState } from "react";


interface IMapSideModalProps {
    showSideModal: boolean,
    selectedPointData: ISelectedMapPoint,
    onClose: () => void,
    // listViewShown: boolean
    offSetSize: 'small' | 'large' | 'none'
}

const MapSideModal = (props: IMapSideModalProps) => {

    const [sideModalClass, setSideModalClass] = useState("map-details-offset")

    useEffect(() => {
        switch(props.offSetSize){
            case 'small':
                setSideModalClass('map-details-small-offset')
                break
            case 'large':
                setSideModalClass("map-details-large-offset")
                break
            default:
                setSideModalClass('')
                break
        }
    }, [props.offSetSize])
    return (
        <>
            <Dialog
                open={props.showSideModal}
                onClose={() => props.onClose()}
                hideBackdrop={true}
                aria-labelledby="map-details"
                disableScrollLock={true}
                className={sideModalClass}
            >
                <CloseIcon 
                    className="modal-close" 
                    color={"disabled"}
                    onClick={props.onClose}
                />
                <DialogContent>
                    {props.selectedPointData.layer.detailed_view_configs?.details?.map((detail, index) => (
                        <MapSideModalContent 
                            layerDetails={detail} 
                            mapPoint={props.selectedPointData.point} 
                            mapLayer={props.selectedPointData.layer}
                            key={index}
                        />
                    ))}
                </DialogContent>
            </Dialog>
        </>
    )
}

export default MapSideModal